module.exports = __webpack_public_path__ + "static/media/dateIcon.a0fa230d.svg";